import { useEffect, useState } from 'react';
import { Col, Row } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { Area, AreaChart, CartesianGrid, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts';
import { getIssuesOverview } from '../../store/Slices/IssuesSlice';
import { createIssueIcon, highPriorityIssueIcon, openIssueIcon, resolvedIssueIcon, visualizeChartBlackIcon, visualizeChartWhiteIcon } from '../../utils/svgs';

const IssuesBoxChart = () => {
    const dispatch = useDispatch();
    const [showChart, setShowChart] = useState(false);

    const { issuesOverviewData } = useSelector((state) => state.issues)

    useEffect(() => {
        dispatch(getIssuesOverview());
    }, [])

    // Prepare chart data
    const openIssueData = issuesOverviewData?.openIssue?.openIssueChart?.map(item => ({
        month: item.month,
        count: item.count
    })) || [];

    const resolvedIssueData = issuesOverviewData?.resolvedIssue?.resolvedIssueChart?.map(item => ({
        month: item.month,
        count: item.count
    })) || [];

    const createdIssueData = issuesOverviewData?.createdIssue?.createdIssueChart?.map(item => ({
        month: item.month,
        count: item.count
    })) || [];

    const highPriorityIssueData = issuesOverviewData?.highPriorityIssue?.highPriorityIssueChart?.map(item => ({
        month: item.month,
        count: item.count
    })) || [];

    return (
        <div className='service_box_chart_main'>
            <div className='service_box_chart'>
                {
                    !showChart ?
                        <span onClick={() => setShowChart(!showChart)}>{visualizeChartBlackIcon}</span>
                        :
                        <span onClick={() => setShowChart(!showChart)}>{visualizeChartWhiteIcon}</span>
                }
            </div>

            <div>
                <Row>
                    <Col md={3}>
                        <div className='service_box_chart_item'>
                            <div className='item_details'>
                                <div>
                                    <h6>Open Issues</h6>
                                    <div>{issuesOverviewData?.openIssue?.total || 0}</div>

                                </div>
                                <div>
                                    <span>{openIssueIcon}</span>
                                </div>
                            </div>
                            {
                                showChart &&
                                <div style={{ width: '100%', height: 180, marginTop: 15 }}>
                                    <ResponsiveContainer>
                                        <AreaChart
                                            data={openIssueData}
                                            margin={{ top: 10, right: 0, left: -25, bottom: 0 }}
                                        >
                                            <defs>
                                                <linearGradient id="colorCount" x1="0" y1="0" x2="0" y2="1">
                                                    <stop offset="0%" stopColor="#43b649" stopOpacity={0.8} />
                                                    <stop offset="100%" stopColor="#43b649" stopOpacity={0.2} />
                                                </linearGradient>
                                            </defs>
                                            <XAxis dataKey="month" tick={{ fontSize: 13 }} />
                                            <YAxis tick={{ fontSize: 13 }} />
                                            <CartesianGrid strokeDasharray="3 3" />
                                            <Tooltip />
                                            <Area
                                                type="monotone"
                                                dataKey="count"
                                                stroke="#43b649"
                                                fill="url(#colorCount)"
                                                strokeWidth={2}
                                            />
                                        </AreaChart>
                                    </ResponsiveContainer>
                                </div>
                            }

                        </div>
                    </Col>
                    <Col md={3}>
                        <div className='service_box_chart_item'>
                            <div className='item_details'>
                                <div>
                                    <h6>Resolved Issues</h6>
                                    <div>{issuesOverviewData?.resolvedIssue?.total || 0}</div>

                                </div>
                                <div>
                                    <span>{resolvedIssueIcon}</span>
                                </div>
                            </div>
                            {
                                showChart &&
                                <div style={{ width: '100%', height: 180, marginTop: 15 }}>
                                    <ResponsiveContainer>
                                        <AreaChart
                                            data={resolvedIssueData}
                                            margin={{ top: 10, right: 0, left: -15, bottom: 0 }}
                                        >
                                            <defs>
                                                <linearGradient id="serviceCost" x1="0" y1="0" x2="0" y2="1">
                                                    <stop offset="0%" stopColor="#FF9500" stopOpacity={0.8} />
                                                    <stop offset="100%" stopColor="#FF9500" stopOpacity={0.2} />
                                                </linearGradient>
                                            </defs>
                                            <XAxis dataKey="month" tick={{ fontSize: 13 }} />
                                            <YAxis tick={{ fontSize: 13 }} />
                                            <CartesianGrid strokeDasharray="3 3" />
                                            <Tooltip />
                                            <Area
                                                type="monotone"
                                                dataKey="count"
                                                stroke="#FF9500"
                                                fill="url(#serviceCost)"
                                                strokeWidth={2}
                                            />
                                        </AreaChart>
                                    </ResponsiveContainer>
                                </div>
                            }
                        </div>
                    </Col>
                    <Col md={3}>
                        <div className='service_box_chart_item'>
                            <div className='item_details'>
                                <div>
                                    <h6>Created Issues</h6>
                                    <div>{issuesOverviewData?.createdIssue?.total || 0}</div>

                                </div>
                                <div>
                                    <span>{createIssueIcon}</span>
                                </div>
                            </div>
                            {
                                showChart &&
                                <div style={{ width: '100%', height: 180, marginTop: 15 }}>
                                    <ResponsiveContainer>
                                        <AreaChart
                                            data={createdIssueData}
                                            margin={{ top: 10, right: 0, left: -25, bottom: 0 }}
                                        >
                                            <defs>
                                                <linearGradient id="pendingMaintenance" x1="0" y1="0" x2="0" y2="1">
                                                    <stop offset="0%" stopColor="#F8E34F" stopOpacity={0.8} />
                                                    <stop offset="100%" stopColor="#F8E34F" stopOpacity={0.2} />
                                                </linearGradient>
                                            </defs>
                                            <XAxis dataKey="month" tick={{ fontSize: 13 }} />
                                            <YAxis tick={{ fontSize: 13 }} />
                                            <CartesianGrid strokeDasharray="3 3" />
                                            <Tooltip />
                                            <Area
                                                type="monotone"
                                                dataKey="count"
                                                stroke="#F8E34F"
                                                fill="url(#pendingMaintenance)"
                                                strokeWidth={2}
                                            />
                                        </AreaChart>
                                    </ResponsiveContainer>
                                </div>
                            }
                        </div>
                    </Col>
                    <Col md={3}>
                        <div className='service_box_chart_item'>
                            <div className='item_details'>
                                <div>
                                    <h6>High Priority Issues</h6>
                                    <div>{issuesOverviewData?.highPriorityIssue?.total || 0}</div>

                                </div>
                                <div>
                                    <span>{highPriorityIssueIcon}</span>
                                </div>
                            </div>
                            {
                                showChart &&
                                <div style={{ width: '100%', height: 180, marginTop: 15 }}>
                                    <ResponsiveContainer>
                                        <AreaChart
                                            data={highPriorityIssueData}
                                            margin={{ top: 10, right: 0, left: -25, bottom: 0 }}
                                        >
                                            <defs>
                                                <linearGradient id="colorUpcoming" x1="0" y1="0" x2="0" y2="1">
                                                    <stop offset="0%" stopColor="#4014B8" stopOpacity={0.5} />
                                                    <stop offset="100%" stopColor="#4014B8" stopOpacity={0.1} />
                                                </linearGradient>
                                            </defs>
                                            <XAxis dataKey="month" tick={{ fontSize: 13 }} />
                                            <YAxis tick={{ fontSize: 13 }} />
                                            <CartesianGrid strokeDasharray="3 3" />
                                            <Tooltip />
                                            <Area
                                                type="monotone"
                                                dataKey="count"
                                                stroke="#4014B8"
                                                fill="url(#colorUpcoming)"
                                                strokeWidth={2}
                                            />
                                        </AreaChart>
                                    </ResponsiveContainer>
                                </div>
                            }
                        </div>
                    </Col>
                </Row>
            </div>
        </div>
    )
}

export default IssuesBoxChart